export const formatDate = (date: Date | string): string => {
    if (typeof date === 'string') {
        date = new Date(date);
    }

    if (!(date instanceof Date) || isNaN(date.getTime())) {
        return 'N/A'; 
    }

    // Convert UTC to local time
    const localDate = new Date(date.getTime() - (date.getTimezoneOffset() * 60000));

    const day = localDate.getDate().toString().padStart(2, '0');
    const month = (localDate.getMonth() + 1).toString().padStart(2, '0'); // Mese inizia da 0
    const year = localDate.getFullYear();
    const hours = localDate.getHours().toString().padStart(2, '0');
    const minutes = localDate.getMinutes().toString().padStart(2, '0');

    return `${day}/${month}/${year} ${hours}:${minutes}`;
};

export const formatDateDayMonthYear = (date: Date | string): string => {
    if (typeof date === 'string') {
        date = new Date(date);
    }

    if (!(date instanceof Date) || isNaN(date.getTime())) {
        return 'N/A'; 
    }

    // Convert UTC to local time
    const localDate = new Date(date.getTime() - (date.getTimezoneOffset() * 60000));

    const day = localDate.getDate().toString().padStart(2, '0');
    const month = (localDate.getMonth() + 1).toString().padStart(2, '0'); // Mese inizia da 0
    const year = localDate.getFullYear();

    return `${day}/${month}/${year}`;
};